// ============================================================
// 客户端路由实例
// 菜单走 GET /customer/user/info → menus
// ============================================================
import { createDynamicRouter } from "@shared/router";
import Layout from "@shared/layout/index.vue";
import { fetchCurrentUserInfo } from "@app/api/user";
import { useCurrentUserStore } from "@app/store/modules/currentUser";
import { staticRoutes } from "./routes";
import "./routePages";

/**
 * 顶栏 InSiteMessageDrawer 的「查看全部」跳 /inSiteMessage/list?category=X。
 * 即便后端 customer menus 不下发 /inSiteMessage，guaranteedRoutes 也能保证跳转不 404。
 */
const guaranteedRoutes = [
    {
        path: "/inSiteMessage",
        component: Layout,
        meta: { hidden: true },
        children: [
            {
                path: "list",
                name: "InSiteMessageList",
                component: () => import("@app/views/inSiteMessage/list/index.vue"),
                meta: { title: "消息列表", hidden: true },
            },
            {
                path: "detail",
                name: "InSiteMessageDetail",
                component: () => import("@app/views/inSiteMessage/detail/index.vue"),
                meta: { title: "消息详情", hidden: true },
            },
        ],
    },
];

const router = createDynamicRouter({
    staticRoutes,
    guaranteedRoutes,
    fetchUserMenus: async () => {
        const data = await fetchCurrentUserInfo();
        // 守卫往往先于 App bootstrap 拉 info：同步水合，强制改密弹窗才能及时打开
        useCurrentUserStore().hydrateFromInfo(data);
        return { menus: data.menus ?? [], buttonPages: data.buttonPages ?? [] };
    },
    layout: Layout,
    whiteList: ["/login", "/register", "/jumpLogin", "/404", "/403"],
    baseTitle: import.meta.env.VITE_APP_TITLE || "1P客户端",
    loginPage: () => import("@app/views/login.vue"),
    requireAuth: true,
});

export default router;
